const INITIAL_VALUES = {
  zoneNum: '',
  zoneName: '',
};

export default INITIAL_VALUES;
